import { render, staticRenderFns } from "./BarraDeCarteria.vue?vue&type=template&id=3dda389c&scoped=true&"
import script from "./BarraDeCarteria.vue?vue&type=script&lang=js&"
export * from "./BarraDeCarteria.vue?vue&type=script&lang=js&"
import style0 from "./BarraDeCarteria.vue?vue&type=style&index=0&id=3dda389c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dda389c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dda389c')) {
      api.createRecord('3dda389c', component.options)
    } else {
      api.reload('3dda389c', component.options)
    }
    module.hot.accept("./BarraDeCarteria.vue?vue&type=template&id=3dda389c&scoped=true&", function () {
      api.rerender('3dda389c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/VisaoGeral/internalTemplates/BarraDeCarteria.vue"
export default component.exports